<template>
  <div class="hello">
    <div class="my-8">
      <image-uploader
        :preview="true"
        :className="['fileinput', { 'fileinput--loaded': hasImage }]"
        capture="environment"
        :debug="1"
        doNotResize="gif"
        :autoRotate="true"
        outputFormat="file"
        @input="setImage"
        class="image-uploader"
      >
        <label for="fileInput" slot="upload-label">
          <figure>
            <i class="fa fa-image" style="font-size: 40px"></i>
          </figure>
          <span class="upload-caption">{{
            hasImage ? "جایگذاری" : "برای بارگزاری کلیک کنید!"
          }}</span>
        </label>
      </image-uploader>
      <img :src="imageUrl" height="200" v-if="image == '' && imageUrl" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["imageUrl"],
  data() {
    return {
      hasImage: false,
      image: "",
    };
  },
  methods: {
    setImage: function (output) {
      this.showImage = false;
      this.hasImage = true;
      this.image = output;
      this.$emit("image-file", this.image);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#fileInput {
  display: none;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.my-8 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.image-uploader {
  display: flex;
  flex-direction: column-reverse;
  img {
    height: 150px;
    width: 150px;
    background: #f2f3f7;
    border: 3px solid #b1b1b1;
    border-radius: 15px;
  }
  label {
    width: 150px;
    text-align: center;
  }
}
.upload-caption {
  color: rgb(66, 66, 255);
}
</style>
